import { useEffect } from 'react';
import { Button } from '@quicktools/shared-components';
import MobileSliderModal from '@quicktools/shared-components/components/core/MobileSliderModal/MobileSliderModal';
import { EmojiVariant } from '@quicktools/emojis';

import analytics from '../../services/analytics';
import CategoryFilter from '../CategoryFilter';
import DeviceFilter from '../DeviceFilter';

import useStyles from './styles';

interface IFilterModal {
  changeCategory: (c: string, t: string, s: string) => void;
  changeDeviceType: (deviceType: string) => void;
  closeModal: () => void;
  selectedCategory: string;
  emojiDeviceType: EmojiVariant;
}

export default function FilterModal({
  changeCategory,
  changeDeviceType,
  closeModal,
  selectedCategory,
  emojiDeviceType,
}: IFilterModal) {
  const styles = useStyles();

  useEffect(() => {
    analytics.filterOpen();
  }, []);

  return (
    <MobileSliderModal onClose={closeModal}>
      <CategoryFilter
        heading="Select category"
        onSelectItem={changeCategory}
        selectedCategory={selectedCategory}
      />
      <DeviceFilter
        heading="Select device type"
        changeType={changeDeviceType}
        selected={emojiDeviceType}
      />
      <Button className={styles.button} type="button" variant="primary" onClick={closeModal}>
        Apply
      </Button>
    </MobileSliderModal>
  );
}
